<template>
  <header
    class="site-header"
    :class="{ 'is-antidrone': isAntiDrone, 'is-english': isEnglish }"
  >
    <!-- 上栏：品牌 +（中文：菜单｜英文：语言/联系） -->
    <div class="header-inner header-top-inner">
      <router-link :to="brandLink" class="brand-logo">
        {{ isEnglish ? 'Hiray Industrial Technology' : '河南汇锐工业技术有限公司' }}
      </router-link>

      <ul v-if="!isEnglish" class="nav-menu">
        <li v-for="(item, index) in currentMenuItems" :key="'zh-' + index">
          <router-link
            :to="item.to"
            class="nav-item"
            :class="{ active: isItemActive(item) }"
          >
            {{ item.name }}
          </router-link>
        </li>
      </ul>

      <div v-else class="top-bar-links">
        <router-link
          v-if="rightLink"
          :to="rightLink.to"
          class="top-link-item"
        >
          {{ rightLink.name }}
        </router-link>
        <router-link :to="langLink.to" class="top-link-item">
          {{ langLink.name }}
        </router-link>
        <router-link :to="contactLink" class="top-link-item">
          Contact
        </router-link>
      </div>
    </div>

    <!-- 英文：下栏灰色导航条 -->
    <div v-if="isEnglish" class="header-nav-bar">
      <div class="header-inner">
        <ul class="nav-menu">
          <li v-for="(item, index) in currentMenuItems" :key="'en-' + index">
            <router-link
              :to="item.to"
              class="nav-item"
              :class="{ active: isItemActive(item) }"
            >
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- 中文：下方快捷入口 -->
    <div v-else class="header-inner header-links-inner">
      <div class="top-bar-links">
        <router-link
          v-if="rightLink"
          :to="rightLink.to"
          class="top-link-item"
        >
          {{ rightLink.name }}
        </router-link>
        <router-link :to="langLink.to" class="top-link-item">
          {{ langLink.name }}
        </router-link>
        <router-link :to="contactLink" class="top-link-item">
          联系方式
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    routePath() {
      return this.$route.path;
    },
    isEnglish() {
      if (this.type === 'english') return true;
      return this.$route.query.lang === 'en';
    },
    isAntiDroneRoute() {
      if (this.type === 'antidrone') return true;
      const antiDroneRoutes = [
        '/',
        '/products',
        '/products/integrated-system',
        '/products/positioning-matrix',
        '/products/capability-matrix',
        '/solutions/c-uas',
        '/solutions/c-uas-zh',
        '/solutions/c-uas-en',
        '/solutions/c-uas-zh',
        '/solutions/c-uas-en',
        '/projects'
      ];
      return antiDroneRoutes.includes(this.routePath);
    },
    isAntiDrone() {
      return this.isAntiDroneRoute;
    },
    brandLink() {
      if (this.isEnglish) {
        return { path: '/', query: { lang: 'en' } };
      }
      return '/';
    },
    contactLink() {
      // 反无人机板块跳首页联系区，保持反无人机导航
      if (this.isAntiDrone) {
        if (this.isEnglish) {
          return { path: '/', query: { lang: 'en' }, hash: '#contact' };
        }
        return { path: '/', hash: '#contact' };
      }
      if (this.isEnglish) {
        return { path: '/about', query: { lang: 'en' }, hash: '#contact' };
      }
      return { path: '/about', hash: '#contact' };
    },
    currentMenuItems() {
      if (this.isEnglish && this.isAntiDrone) {
        return [
          {
            name: 'Home',
            to: { path: '/', query: { lang: 'en' } }
          },
          {
            name: 'Detection Series',
            to: { path: '/products', query: { cat: 'detect', lang: 'en' } }
          },
          {
            name: 'Jamming Series',
            to: { path: '/products', query: { cat: 'jamming', lang: 'en' } }
          },
          {
            name: 'Physical Interception',
            to: { path: '/products', query: { cat: 'intercept', lang: 'en' } }
          },
          {
            name: 'Integrated Detection & Countermeasure',
            to: { path: '/products', query: { cat: 'integrated', lang: 'en' } }
          },
          {
            name: 'Low-Altitude Security Platform',
            to: { path: '/solutions/c-uas', query: { lang: 'en' } }
          },
          {
            name: 'Solutions',
            to: { path: '/products', query: { cat: 'solution', lang: 'en' } }
          },
          {
            name: 'Product Positioning Matrix',
            to: { path: '/products/positioning-matrix', query: { lang: 'en' } }
          },
          {
            name: 'Product Capability Matrix',
            to: { path: '/products/capability-matrix', query: { lang: 'en', cuas: '1' } }
          },
          {
            name: 'Project Site',
            to: { path: '/projects', query: { lang: 'en' } }
          }
        ];
      }
      if (this.isEnglish) {
        return [
          {
            name: 'Solutions',
            to: { path: '/solutions/industry', query: { lang: 'en' } }
          },
          {
            name: 'Thermal Spray Equipment',
            to: { path: '/products/catalog', query: { section: 'equipment', lang: 'en' } }
          },
          {
            name: 'Spray Gun',
            to: { path: '/products/catalog', query: { section: 'guns', lang: 'en' } }
          },
          {
            name: 'Consumables',
            to: { path: '/products/catalog', query: { section: 'consumables', lang: 'en' } }
          },
          {
            name: 'Auxiliary Equipment',
            to: { path: '/products/catalog', query: { section: 'auxiliary', lang: 'en' } }
          },
          {
            name: 'About HIRAY',
            to: { path: '/about', query: { lang: 'en' } }
          },
          {
            name: 'Project Site',
            to: { path: '/projects', query: { lang: 'en' } }
          }
        ];
      }
      if (this.isAntiDrone) {
        return [
          { name: '首页', to: '/' },
          { name: '侦测系列', to: { path: '/products', query: { cat: 'detect' } } },
          { name: '干扰系列', to: { path: '/products', query: { cat: 'jamming' } } },
          { name: '物理拦截系列', to: { path: '/products', query: { cat: 'intercept' } } },
          { name: '侦反一体系列', to: { path: '/products', query: { cat: 'integrated' } } },
          { name: '低空安全管理平台', to: '/solutions/c-uas' },
          { name: '解决方案', to: { path: '/products', query: { cat: 'solution' } } },
          { name: '产品定位矩阵', to: '/products/positioning-matrix' },
          { name: '产品能力矩阵', to: '/products/capability-matrix' },
          { name: '工程现场', to: '/projects' }
        ];
      }
      return [
        { name: '首页', to: '/' },
        { name: '解决方案', to: '/solutions/industry' },
        { name: '热喷涂设备', to: { path: '/products/catalog', query: { section: 'equipment' } } },
        { name: '喷枪', to: { path: '/products/catalog', query: { section: 'guns' } } },
        { name: '消耗品', to: { path: '/products/catalog', query: { section: 'consumables' } } },
        { name: '辅助配套设备', to: { path: '/products/catalog', query: { section: 'auxiliary' } } },
        { name: '关于汇锐', to: '/about' },
        { name: '工程现场', to: '/projects' }
      ];
    },
    rightLink() {
      // 反无人机板块不展示热喷涂入口
      if (this.isAntiDrone) return null;
      if (this.isEnglish) {
        return {
          name: 'Counter-UAS Link',
          to: { path: '/', query: { lang: 'en' } }
        };
      }
      return { name: '反无人机入口', to: '/' };
    },
    langLink() {
      if (this.isEnglish) {
        if (this.isAntiDrone) {
          return { name: 'Chinese', to: { path: '/', query: { lang: 'zh' } } };
        }
        return {
          name: 'Chinese',
          to: { path: '/products/catalog', query: { section: 'equipment', lang: 'zh' } }
        };
      }
      if (this.isAntiDrone) {
        return {
          name: 'ENGLISH',
          to: { path: '/', query: { lang: 'en' } }
        };
      }
      return { name: 'ENGLISH', to: { path: '/', query: { lang: 'en' } } };
    }
  },
  methods: {
    resolvePath(to) {
      if (!to) return '';
      if (typeof to === 'string') return to.split('?')[0];
      return to.path || '';
    },
    resolveQuery(to) {
      if (!to || typeof to === 'string') {
        if (typeof to === 'string' && to.includes('?')) {
          const q = {};
          to.split('?')[1].split('&').forEach((pair) => {
            const [k, v] = pair.split('=');
            q[k] = decodeURIComponent(v || '');
          });
          return q;
        }
        return {};
      }
      return to.query || {};
    },
    isItemActive(item) {
      const currentPath = this.$route.path;
      const itemPath = this.resolvePath(item.to);
      const itemQuery = this.resolveQuery(item.to);

      if (item.to && item.to.hash) {
        return currentPath === itemPath && this.$route.hash === item.to.hash;
      }
      if (currentPath === '/') {
        return item.name === '首页' || item.name === 'Home';
      }
      if (currentPath === '/about') {
        return item.name === '关于汇锐' || item.name === 'About HIRAY';
      }
      if (currentPath === '/solutions/industry') {
        return item.name === 'Solutions' || item.name === '解决方案';
      }
      if (
        currentPath === '/solutions/c-uas-zh' ||
        currentPath === '/solutions/c-uas-en' ||
        currentPath === '/solutions/c-uas-zh' ||
        currentPath === '/solutions/c-uas-en'
      ) {
        return item.name === 'Solutions' || item.name === '解决方案';
      }
      if (currentPath === '/products/catalog') {
        const section = this.$route.query.section || 'equipment';
        const sectionMap = {
          equipment: ['热喷涂设备', 'Thermal Spray Equipment'],
          guns: ['喷枪', 'Spray Gun'],
          consumables: ['消耗品', 'Consumables'],
          auxiliary: ['辅助配套设备', 'Auxiliary Equipment']
        };
        return (sectionMap[section] || []).includes(item.name);
      }
      if (currentPath === '/products/radio-detection' || currentPath === '/products/countermeasure-system') {
        const section = this.$route.query.section || 'equipment';
        const sectionMap = {
          equipment: ['热喷涂设备', 'Thermal Spray Equipment'],
          guns: ['喷枪', 'Spray Gun'],
          consumables: ['消耗品', 'Consumables'],
          auxiliary: ['辅助配套设备', 'Auxiliary Equipment']
        };
        return (sectionMap[section] || []).includes(item.name);
      }
      if (currentPath === '/products') {
        const cat = this.$route.query.cat || 'detect';
        const map = {
          detect: ['侦测系列', 'Detection Series'],
          jamming: ['干扰系列', 'Jamming Series'],
          intercept: ['物理拦截系列', 'Physical Interception'],
          integrated: ['侦反一体系列', 'Integrated Detection & Countermeasure'],
          solution: ['解决方案', 'Solutions']
        };
        return (map[cat] || []).includes(item.name);
      }
      if (currentPath === '/products/positioning-matrix') {
        return item.name === '产品定位矩阵' || item.name === 'Product Positioning Matrix';
      }
      if (currentPath === '/products/capability-matrix') {
        return item.name === '产品能力矩阵' || item.name === 'Product Capability Matrix';
      }
      if (currentPath === '/solutions/c-uas') {
        return (
          item.name === '低空安全管理平台' ||
          item.name === 'Low-Altitude Security Platform'
        );
      }
      if (currentPath === '/projects') {
        return item.name === '工程现场' || item.name === 'Project Site';
      }
      if (itemQuery.cat || itemQuery.section) {
        return currentPath === itemPath;
      }
      return currentPath === itemPath;
    }
  }
};
</script>

<style scoped>
/* 继承 common.css 中 .site-header 的样式 */
</style>
